export default {
  BUYER: 'buyer',
  SELLER: 'seller',
};
